export default __webpack_public_path__ + "static/index_hero_bg01-097bb43f460752d7a022cb876a31490b.jpg";